import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deFormal from './i18n/de/formal';
import deInformal from './i18n/de/informal';
import enFormal from './i18n/en/formal';
import { toResourceLanguageCode } from './i18n/languageCode';

const resources = {
    [toResourceLanguageCode('de-FORMAL')]: {
        envago: deFormal,
    },
    [toResourceLanguageCode('de-INFORMAL')]: {
        envago: deInformal,
    },
    [toResourceLanguageCode('en-FORMAL')]: {
        envago: enFormal,
    },
};

i18n.use(initReactI18next).init({
    debug: process.env.NODE_ENV === 'development',
    resources: resources,
    lng: 'de-FORMAL',
    ns: ['envago'],
    defaultNS: 'envago',
    interpolation: {
        escapeValue: false,
    },
    returnObjects: true,
});

export default i18n;
